import styled from "styled-components";
import Select from "react-select";
import Botao from "../../../componentes/Botao";
import { InputMask } from "@react-input/mask";
import { editarIngresso } from "../../../servicos/ticketsServices";

const ContainerEditar = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #000000ab;
    display: ${props => props.$mostrar? "block": "none"};
    z-index: 99;
`
const SecaoEditar = styled.div`
    position: relative;
    top: 100px;
    width: 400px;
    margin: auto;
    background-color: white;
    border-radius: 10px;
    align-items: center;
    padding: 20px 20px 5px 20px;
    button {
        margin: 10px;
    }
    p {
        color: black;
        font-size: 16px;
        font-weight: bold;
    }
`
const PEditar = styled.p`
    color: ${props => props.$cor? props.$cor: "#252525"};
    width: ${props => props.$largura? props.$largura: "200px"};
    margin: ${props => props.$margem? props.$margem: "10px"};
`
const DivLinha = styled.div`
    width: 100%;
    display: ${props => props.$hide? "none": "flex"};
    align-items: center;
    margin-bottom: ${props => props.$marginBottom? props.$marginBottom: "0"};
    button {
        margin-top: 0px;
    }
`
const DivProps = styled.div`
    width: ${props => props.$largura || "100px"};
`
const DivVisitante = styled.div`
    display: block;    
`
const InputEditar = styled.input`
    border-radius: 4px;
    border: 2px solid rgba(58, 23, 14, 0.308);
    background-color: white;
    color: black;
    height: 34px;
    width: ${props => props.$largura? props.$largura: "200px"};
    font-size: 16px;
`
const DivBotoes = styled.div`
    display: flex;
`

export function EditarIngresso(ingresso, setIngresso, showEditar, setShowEditar, guias, original) {    
    const opcoesTipo = [
        { value: "individual", label: "INDIVIDUAL" },
        { value: "individualOnline", label: "INDIVIDUAL-ONLINE" },
        { value: "infantilOnline", label: "INFANTIL-ONLINE" },
        { value: "infantil", label: "INFANTIL" },
        { value: "promocionalEscolar", label: "PROMOCIONAL-ESCOLAR" },
        { value: "promocionalExcursao", label: "PROMOCIONAL-EXCURSÃO" },
        { value: "cortesia", label: "CORTESIA" },
        { value: "parksnet", label: "PARKSNET" },
        { value: "promocional", label: "PROMOCIONAL" },
        { value: "promocionalOnline", label: "PROMOCIONAL-ONLINE" }
    ];
    
    async function salvarIngresso() {
        let ingressoAlterado = false;
        let visitanteAlterado = false;
        let atualizacao = {};

        // Comparação se teve alguma alteração no visitante
        if (!(original.visitante.nome === ingresso.visitante.nome && original.visitante.email === ingresso.visitante.email && original.visitante.celular === ingresso.visitante.celular)) {
            visitanteAlterado = true;
            atualizacao.visitante = {
                _id: ingresso.visitante._id,
                nome: ingresso.visitante.nome,
                email: ingresso.visitante.email,
                celular: ingresso.visitante.celular
            };
        }
        
        // Comparação se teve alguma alteração no ingresso
        if (!(original.tipo === ingresso.tipo && original.guia?._id === ingresso.guia?._id && original.motivoCortesia === ingresso.motivoCortesia)) {
            ingressoAlterado = true;
            atualizacao.ingresso = {
                tipo: ingresso.tipo,
            }
            if (ingresso.motivoCortesia) atualizacao.ingresso.motivoCortesia = ingresso.motivoCortesia;
            if (ingresso.guia) atualizacao.ingresso.guia = ingresso.guia._id;
        }

        if (!ingressoAlterado && !visitanteAlterado) return;

        editarIngresso(original._id, atualizacao).then( res => {
            if (res.status === 200) setShowEditar(false); else {
                console.log(res);
                setShowEditar(false);
            }
        })
    }

    return (<ContainerEditar $mostrar={showEditar}>
        <SecaoEditar>
            <PEditar $largura="300px">Editando ingresso {ingresso.numero || "-"}</PEditar>

            <DivLinha $marginBottom={"10px"}>
                <DivProps>Visitante</DivProps>
                <DivVisitante>
                    <DivLinha>
                        <PEditar $largura="70px">Nome</PEditar>
                        <InputEditar type="text" value={ingresso.visitante?.nome || ""} onChange={ e => setIngresso({...ingresso, visitante: {...ingresso.visitante, nome: e.target.value }})}/>
                    </DivLinha>
                    <DivLinha>
                        <PEditar $largura="70px">E-mail</PEditar>
                        <InputEditar type="text" value={ingresso.visitante?.email || ""} onChange={ e => setIngresso({...ingresso, visitante: {...ingresso.visitante, email: e.target.value }})}/>
                    </DivLinha>
                    <DivLinha>
                        <PEditar $largura="70px">Telefone</PEditar>
                        <InputMask
                            autoComplete="on"
                            onChange={ e => setIngresso({...ingresso, visitante: {...ingresso.visitante, celular: e.target.value }})}
                            value={ingresso.visitante?.celular || ""}
                            // onInput={event => setDados({...dados, visitante: {...dados.visitante, celular: event.target.value}})} 
                            // value={dados.visitante.celular} 
                            component={InputEditar} 
                            mask="(__) _____-____" 
                            replacement={{ _: /\d/ }}
                        />
                        {/* <InputEditar type="text" value={ingresso.visitante?.celular || ""} onChange={ e => setIngresso({...ingresso, visitante: {...ingresso.visitante, celular: e.target.value }})}/> */}
                    </DivLinha>
                </DivVisitante>
            </DivLinha>
            <DivLinha $marginBottom={"10px"}>
                <DivProps>Tipo</DivProps>
                <Select 
                    options={opcoesTipo}
                    placeholder="?"
                    value={opcoesTipo.find( element => element.label === ingresso.tipo )}
                    onChange={e => setIngresso({...ingresso, tipo: e.label})}
                    styles={{
                        control: (baseStyles, state) => ({
                            ...baseStyles,
                            marginBottom: 10,
                            border: "2px solid rgba(58, 23, 14, 0.308)",
                            width: "300px",
                            borderColor: state.hover ? 'black' : 'rgba(58, 23, 14, 0.308)' 
                        }),
                        option: (baseStyles) => ({
                            ...baseStyles,
                            color: "black"
                        })
                    }}
                />
            </DivLinha>
            <DivLinha $marginBottom="10px" $hide={ingresso.tipo !== "CORTESIA"}>
                <DivProps>Motivo cortesia</DivProps>
                <InputEditar $largura="300px" type="text" value={ingresso?.motivoCortesia} onChange={ e => setIngresso({...ingresso, motivoCortesia: e.target.value})}/>
            </DivLinha>
            <DivLinha $marginBottom="10px">
                <DivProps>Guia</DivProps>
                <Select 
                    options={guias}
                    isClearable
                    placeholder="Selecione o guia"
                    value={guias.find( element => element.value === ingresso.guia?._id )}
                    onChange={e => {
                        if (e) {
                            setIngresso({...ingresso, guia: {_id: e.value, nome: e.label}})
                        } else {
                            setIngresso({...ingresso, guia: null})
                        }
                    }}
                    styles={{
                        control: (baseStyles, state) => ({
                            ...baseStyles,
                            marginBottom: 10,
                            border: "2px solid rgba(58, 23, 14, 0.308)",
                            width: "300px",
                            borderColor: state.hover ? 'black' : 'rgba(58, 23, 14, 0.308)' 
                        }),
                        option: (baseStyles) => ({
                            ...baseStyles,
                            color: "black"
                        })
                    }}
                />
            </DivLinha>
            <DivBotoes>
                <Botao onClick={() => salvarIngresso()}>Salvar</Botao>
                <Botao onClick={() => {
                    setIngresso(original);
                    setShowEditar(false);
                }}>Cancelar</Botao>
            </DivBotoes>
        </SecaoEditar>
    </ContainerEditar>)
}